import { createMainResourceREST, mergeSummaryBodyField } from '../resource';
import {
  CRSendBookBody,
  CRSendBookBodyAPI,
  CRSendBookKey,
  CRSendBookSummary,
  CRSendBookSummaryAPI,
  SendBooksLoadMultiQueryParams,
  SendBooksState,
} from './types';

type AnySendBook =
  | CRSendBookKey
  | CRSendBookSummary
  | CRSendBookBody
  | undefined;

function sameKeySendBook(a: AnySendBook, b: AnySendBook): boolean {
  return a?.sendBookId === b?.sendBookId;
}

function getEndpointSendBook(key: AnySendBook): string {
  return key ? `/send-books/${key.sendBookId}/` : '/send-books/';
}

const sendBooksStateSelector = (state: any): SendBooksState => state.sendBooks;
const sendBookKeySelector = ({
  sendBookId,
}: CRSendBookBody | CRSendBookSummary): CRSendBookKey => ({ sendBookId });

function parseSendBookSummary(
  sendBookSummary: CRSendBookSummaryAPI,
): CRSendBookSummary {
  return sendBookSummary;
}

function parseSendBookBody(sendBookBody: CRSendBookBodyAPI): CRSendBookBody {
  return sendBookBody;
}

function mergeSendBookBody(
  lastBody: CRSendBookBody,
  currentBody: CRSendBookBody,
) {
  return currentBody;
}

function combineSummaryBodySendBook(
  summary?: CRSendBookSummary,
  detail?: CRSendBookBody,
): CRSendBookSummary {
  const merge = mergeSummaryBodyField(summary, detail);
  return {
    sendBookId: merge('sendBookId'),
    sendBookName: merge('sendBookName'),
    inUse: merge('inUse'),
    rowKey: merge('rowKey'),
  };
}

const {
  actions: sendBooksActions,
  reducer: sendBooksReducer,
  watches: sendBooksWatches,
  rawActions: sendBooksRawActions,
} = createMainResourceREST<
  CRSendBookKey,
  CRSendBookSummary,
  CRSendBookBody,
  CRSendBookSummaryAPI,
  CRSendBookBodyAPI,
  SendBooksLoadMultiQueryParams
>(
  'sendBooks',
  getEndpointSendBook,
  sendBooksStateSelector,
  sameKeySendBook,
  parseSendBookBody,
  parseSendBookSummary,
  mergeSendBookBody,
  combineSummaryBodySendBook,
  // formatSendBookBody,
  // validateSendBook,
);

export * from './types';
export {
  sendBooksActions,
  sendBooksReducer,
  sendBooksWatches,
  sendBooksRawActions,
  sendBooksStateSelector,
  sendBookKeySelector,
};
